import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { kioskstyles } from "./../../kioskstyles";
import KioskStylesReact from "./../../KioskStylesReact";
import {
  loginViaSocket,
  reloginViaSocket,
  checkLoginCodesViaSocket
} from "./HelperFunctions/socketFuntions";
import { displayLoginError } from "./HelperFunctions/ErrorDisplayFunctions";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import CircleButton from "./Components/Buttons/CircleButton";
import Logo from "./Components/Logo";
import LanguageButtons from "./Components/Shared/LanguageButtons";
import SubtitleWrapper from "./Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./Components/Shared/PanelElements/FlexRightPanel";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../utils/Dlog";

import HttpContext from "../../contexts/HTTP/HttpContext";
import KioskContext from "../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { checkView } from "./HelperFunctions/viewFunctions";
import HorizontalLayout from "./Components/ErrorScreen/HorizontalLayout";
import VerticalLayout from "./Components/ErrorScreen/VerticalLayout";

import { checkVersion } from "./HelperFunctions/versionFunctions";

let env = require("./../../env");

function ErrorScreen({ authenticate }) {
  const theme = useTheme();
  const { simplepost } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [errorCode, setErrorCode] = useState("");

  const [kioskkey, setKioskkey] = useState("");

  const [loadingTimer, setLoadingTimer] = useState(null);

  // Limit number of theme request
  const [themeRequested, setThemeRequested] = useState(0);

  const [loginSubscriptionID, setLoginSubscriptionID] = useState(null);
  const [loginLocationAddress, setLoginLocationAddress] = useState(null);
  const [loginLocationName, setLoginLocationName] = useState(null);
  const [loginLocationCode, setLoginLocationCode] = useState(null);
  const [latestVersion, setLatestVersion] = useState(null);
  const [loginWarning, setLoginWarning] = useState(false);
  const [warningSwitchFromName, setWarningSwitchFromName] = useState(null);
  const [warningSwitchFromCode, setWarningSwitchFromCode] = useState(null);
  const [showLoginConfirmModal, setShowLoginConfirmModal] = useState(false);
  const [showVersionMismatchModal, setShowVersionMismatchModal] = useState(
    false
  );

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    syncTimeOffset,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    setQrCode,
    setQrCodeExpireTime,
    setSyncTimeOffset,
    getKioskTheme
  } = useContext(SocketIOContext);

  //params
  // const { customerName } = route.params;

  const navigate = useNavigate();

  const [orientation, setOrientation] = useState(
    window.screen.orientation.type
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientation(window.screen.orientation.type);
    };

    window.screen.orientation.addEventListener(
      "change",
      handleOrientationChange
    );

    return () => {
      window.screen.orientation.removeEventListener(
        "change",
        handleOrientationChange
      );
    };
  }, []);

  // //Check if theme is loaded, else ask for themes
  useEffect(() => {
    async function checkAndUpdateThemes() {
      const kioskThemes = await getKioskTheme();

      //Is Empty Object and haven't spamed the server
      if (Object.keys(kioskThemes).length === 0 && themeRequested < 3) {
        let payload = {
          type: "REQUESTTHEME"
        };

        sendEvent(payload);
        setThemeRequested(themeRequested + 1);
      }
    }
    checkAndUpdateThemes();
  }, []);

  //Check and generate a UniqueKioskID
  useEffect(() => {
    let kioskID = localStorage.getItem("kioskID");
    console.log("kioskID from localStorage", kioskID);

    let newKioskID = null;

    if (kioskID == null) {
      //Generate a new one!
      if (crypto.randomUUID != null) {
        newKioskID = crypto.randomUUID();
        localStorage.setItem("kioskID", newKioskID);
      } else {
        //TODO: Remove this case, as this is NOT RECOMMENDED!
        console.log(
          "[WARNING] crypto.randomUUID doesn't exist, HTTPS is probably not enabled. Using fallback."
        );
        newKioskID = mockUniqueID(32);
        localStorage.setItem("kioskID", newKioskID);
      }
    }

    //We dont auto login, since the error is probably that the Subscription is DIABLED
    //   //if Kiosk Key available, attempt auto login
    //   let subscriptionID = localStorage.getItem("subscriptionID");
    //   if (subscriptionID !== null) {
    //     //auto login
    //     setKioskkey(subscriptionID);
    //   }
  }, []);

  //Logic for response from Socket.IO
  useEffect(() => {
    console.log("I think an event happened! (ErrorScreen)", socketEvents);
    if (socketEvents == null) {
      console.log("socketEvents is null, ignoring");
      return;
    }

    let socketdata = socketEvents.data;
    console.log("socketdata", socketdata);

    let result = socketdata.result;
    let action = socketdata.action;

    if (result == "ERROR") {
      setErrorCode(socketdata.errorcode);
      setLoading(false);
      //stop timer
      if (loadingTimer !== null) {
        clearTimeout(loadingTimer);
        setLoadingTimer(null);
      }
    }

    switch (action) {
      case "CHECK_LOGINCODE_ERROR":
        setLoading(false);

        if (loadingTimer !== null) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }
        break;

      case "CHECK_LOGINCODE_SUCCESS":
        setLoading(false);

        if (loadingTimer !== null) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }

        setLoginSubscriptionID(kioskkey);
        setLoginLocationAddress(socketdata.locationAddress);
        setLoginLocationName(socketdata.locationName);
        setLoginLocationCode(socketdata.locationCode);
        setLoginWarning(socketdata.warning);
        setWarningSwitchFromName(socketdata.switchFromName);
        setWarningSwitchFromCode(socketdata.switchFromCode);
        setLatestVersion(socketdata.currentVersion);
        setShowLoginConfirmModal(true);

        const versionUpToDate = checkVersion(socketdata.currentVersion);

        if (!versionUpToDate) {
          setShowVersionMismatchModal(true);
        }
        break;

      //////  NOTE: No Auto-SignIn when there is an error
      case "ADVANCE":
        console.log("ErrorScreen LOGIN", socketdata);
        localStorage.setItem("subscriptionID", kioskkey);
        localStorage.setItem("LocationAddress", socketdata.locationAddress);
        localStorage.setItem("LocationName", socketdata.locationName);

        setLoading(false);

        if (loadingTimer !== null) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }

        setLoginSubscriptionID(kioskkey);
        setLoginLocationAddress(socketdata.locationAddress);
        setLoginLocationName(socketdata.locationName);
        setShowLoginConfirmModal(true);
        //save QR Code is done in the context
        navigate("/language");
        break;

      case "RELOGIN":
        reloginViaSocket(getSocket(), "ERRORSCREEN");
        break;
    }
    console.log("clearSocketEvents", clearSocketEvents);
    clearSocketEvents();
  }, [socketEvents]);

  const updateKioskKey = newkey => {
    // Check if the string is not empty
    if (!newkey || newkey.length === 0) {
      return setKioskkey("");
    }

    // Remove all non-alphanumeric characters and convert to uppercase
    return setKioskkey(newkey.replace(/[^a-zA-Z0-9]/g, "").toUpperCase());
  };

  const confirmLoginAdvanceFunc = async () => {
    //loginViaSocket
    await loginViaSocket(getSocket(), kioskkey);
  };

  const confirmLoginCancelFunc = () => {
    setLoginSubscriptionID(null);
    setLoginLocationAddress(null);
    setLoginLocationName(null);
    setShowLoginConfirmModal(false);
    setShowVersionMismatchModal(false);
  };

  const next = async () => {
    if (!loading) {
      Dlog("next called");

      setLoading(true);
      setErrorCode("");

      await checkLoginCodesViaSocket(getSocket(), kioskkey);

      //Reset loading if longer than 15 secs
      if (loadingTimer !== null) {
        clearTimeout(loadingTimer);
      }

      let timer = setTimeout(function() {
        setLoading(false);
      }, 15000);
      setLoadingTimer(timer);
    }
  };

  const navigatePrinterDebug = async () => {
    navigate("/printerdebug");
  };

  const isNotMobile = useMediaQuery("(min-width:600px)");
  const isLandscape = useMediaQuery("(orientation:landscape)");

  // if (
  //   orientation == "landscape-primary" ||
  //   orientation == "landscape-secondary"
  // ) {
  if (checkView(orientation, getKioskTheme()) == "horizontal") {
    return (
      <HorizontalLayout
        setKioskkeyFunc={updateKioskKey}
        nextFunc={next}
        loading={loading}
        errorCode={errorCode}
        isNotMobile={isNotMobile}
        kioskkey={kioskkey}
        showLoginConfirmModal={showLoginConfirmModal}
        loginLocationAddress={loginLocationAddress}
        loginLocationCode={loginLocationCode}
        loginLocationName={loginLocationName}
        loginWarning={loginWarning}
        warningSwitchFromName={warningSwitchFromName}
        warningSwitchFromCode={warningSwitchFromCode}
        confirmLoginCancelFunc={confirmLoginCancelFunc}
        confirmLoginAdvanceFunc={confirmLoginAdvanceFunc}
        showVersionMismatchModal={showVersionMismatchModal}
        setShowVersionMismatchModal={setShowVersionMismatchModal}
        latestVersion={latestVersion}
      />
    );
  } else {
    return (
      <VerticalLayout
        setKioskkeyFunc={updateKioskKey}
        nextFunc={next}
        loading={loading}
        errorCode={errorCode}
        isNotMobile={isNotMobile}
        kioskkey={kioskkey}
        showLoginConfirmModal={showLoginConfirmModal}
        loginLocationAddress={loginLocationAddress}
        loginLocationCode={loginLocationCode}
        loginLocationName={loginLocationName}
        loginWarning={loginWarning}
        warningSwitchFromName={warningSwitchFromName}
        warningSwitchFromCode={warningSwitchFromCode}
        confirmLoginCancelFunc={confirmLoginCancelFunc}
        confirmLoginAdvanceFunc={confirmLoginAdvanceFunc}
        showVersionMismatchModal={showVersionMismatchModal}
        setShowVersionMismatchModal={setShowVersionMismatchModal}
        latestVersion={latestVersion}
      />
    );
  }
}

function mockUniqueID(length) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export default ErrorScreen;
